import { styled, Theme } from '@mui/material/styles';
import { AutocompleteInput, Create, Datagrid, List, TextInput } from 'react-admin';
import { DefaultToolbar } from '@/components/toolbars';
import { TURN_STYLES } from './theme';

export const actionButtonStyled = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',

  height: '38px',
  padding: '8px 6px',

  fontSize: '13px',

  '& .MuiButton-startIcon': {
    margin: '0',
  },

  '&.Mui-disabled': {
    backgroundColor: 'transparent',
    cursor: 'not-allowed',
    color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryButtonColor : TURN_STYLES.secondaryButtonColor,

    '& .MuiSvgIcon-root': {
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryButtonColor : TURN_STYLES.secondaryButtonColor,
    },
  },

  '& .MuiSvgIcon-root': {
    width: '18px',
    height: '18px',
    color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryAccentColor : TURN_STYLES.secondaryAccentColor,
  },
});

export const CreateStyled = styled(Create)({
  boxShadow: 'none',

  '& .MuiCard-root': {
    border: 'none !important',
    boxShadow: 'none',
  },
});

export const DefaultToolbarStyled = styled(DefaultToolbar)({
  padding: '0 !important',
});

export const LinkStyled = styled('a')(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryAccentColor : TURN_STYLES.secondaryAccentColor,
}));

export const MainListStyled = styled(List)({
  '& .RaList-actions': {
    marginBottom: '8px',
  },
});

export const MainDatagridStyled = styled(Datagrid)(({ theme }) => ({
  '.RaDatagrid-tableWrapper': {
    borderRadius: '8px 8px 0 0',
    overflow: 'hidden',
  },

  '& .MuiTableCell-head': {
    height: '50px',
    fontWeight: '500',
    backgroundColor: TURN_STYLES.tableHeaderColor,

    ...(theme.palette.mode === 'dark'
      ? {
          color: TURN_STYLES.darkSecondaryColor,
          fontWeight: '600',
          backgroundColor: TURN_STYLES.darkTableHeaderColor,
        }
      : {}),
  },

  '& .MuiTableRow-root': {
    height: '50px',

    '& .MuiTableCell-root': {
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
      borderBottom: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkTableHeaderColor : TURN_STYLES.tableHeaderColor}`,
    },

    '&:last-of-type .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },

  /* Candidate Table */
  '& .column-candidate_email': { maxWidth: 200, wordWrap: 'break-word' },
  '& .column-last_name': { maxWidth: 100, wordWrap: 'break-word' },
  '& .column-first_name': { maxWidth: 100, wordWrap: 'break-word' },
  '& .column-package': { maxWidth: 200, wordWrap: 'break-word' },

  /* Check Records Table */
  '& .column-disposition, & .column-offense_description1, & .column-offense, & .column-source, & .column-sub_violations.0.acd_code_description, & .column-sub_violations.0.descriptions.0.short_description, & .column-sub_violations.0.descriptions.0.state_description':
    {
      maxWidth: 300,
      wordWrap: 'break-word',
    },
}));

export const PartnerInputStyled = styled(AutocompleteInput)({
  width: '256px',

  '& .MuiFormControl-root': {
    width: '256px',
  },

  '& .MuiFormLabel-root': {
    backgroundColor: 'transparent',
    lineHeight: '10px',
  },

  '& .MuiInputLabel-shrink': {
    lineHeight: '24px',
  },
});

export const SearchInputStyled = styled(TextInput)({
  '& .MuiFormLabel-root': {
    backgroundColor: 'transparent',
  },
});

export const SecondaryDatagridStyled = styled(Datagrid)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,

  '& .RaDatagrid-tableWrapper': {
    border: 'none',
    borderRadius: theme.palette.mode === 'dark' ? '8px 8px 0 0' : '0',
  },

  '& .MuiTableHead-root': {
    height: '36px',

    '& .MuiTableCell-head': {
      fontWeight: '600',
      borderBottom: 'none',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkTableHeaderColor : TURN_STYLES.tableHeaderColor,
    },
  },

  '& .column-author, & .column-source': { maxWidth: 220, wordWrap: 'break-word' },

  '& .MuiTableBody-root': {
    '& .MuiTableRow-root': {
      height: '45px',

      '& .MuiTableCell-root': {
        color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
        borderBottom: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkTableHeaderColor : TURN_STYLES.tableHeaderColor}`,
      },

      '&:last-of-type .MuiTableCell-root': {
        borderBottom: 'none',
      },
    },
  },
}));
